import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutStateTaxTableList extends Layout {
    layoutheaderStateTaxTableList: LayoutHeader;
    sourceStateTaxTable: DataSource;
    tableStateTaxTableList: Table;
}
